import { useCallback, useEffect, useState } from 'react';
import { getMySpotifyAccounts } from '../../api/auth.api';

export function useSpotifyAccounts(uid) {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!uid) {
      setAccounts([]);
      setLoading(false);
      return;
    }
    try {
      const data = await getMySpotifyAccounts();
      setAccounts(data);
    } catch (error) {
      console.error('useSpotifyAccounts error:', error);
      setAccounts([]);
    } finally {
      setLoading(false);
    }
  }, [uid]);

  useEffect(() => {
    setLoading(true);
    refresh();
  }, [refresh]);

  return { accounts, loading, refresh };
}
